<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'AllocationUnit',
      urlFragment: 'allocation-units',
    };
  },
};
</script>

<style></style>
